import React, { FC } from 'react';
import { AllieText } from '../Text';
import {
  Container,
  ContentContainer,
  StyledCloseButton,
  StyledFooter,
  StyledHeader,
  StyledModal,
} from './ModalV2.styles';
import { IonModalProps } from '../../common/components.types';

export interface AllieModalV2Props extends Omit<IonModalProps, 'onDidDismiss'> {
  isOpen: boolean;
  onDidDismiss?: () => void;
  handleClose: () => void;
  title: string;
  closeBtnText: string;
  hideHeader?: boolean;
  children: React.ReactElement;
  footer?: React.ReactElement;
  width?: string;
  keepContentsMounted?: boolean;
  modalStyle?: React.CSSProperties;
}

export const AllieModalV2: FC<AllieModalV2Props> = ({
  isOpen,
  onDidDismiss,
  handleClose,
  title,
  closeBtnText,
  hideHeader = false,
  children,
  footer,
  width,
  modalStyle = {},
  keepContentsMounted = false,
  ...props
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      width={width}
      backdropDismiss={false}
      onDidDismiss={async () => {
        onDidDismiss?.();
        return Promise.resolve({});
      }}
      {...props}
      keepContentsMounted={keepContentsMounted}
      style={modalStyle}
    >
      <Container>
        {!hideHeader && (
          <StyledHeader>
            <AllieText type="h3" color="neutral-90">
              {title}
            </AllieText>
            <StyledCloseButton
              allieSize="small"
              allieType="secondary"
              corner="rounded-edges"
              allieColor="neutral"
              onclick={handleClose}
            >
              {closeBtnText}
            </StyledCloseButton>
          </StyledHeader>
        )}
        <ContentContainer>{children}</ContentContainer>
        {footer && <StyledFooter>{footer}</StyledFooter>}
      </Container>
    </StyledModal>
  );
};
